export default __webpack_public_path__ + "static/media/normweather.20863ddf.jpg";